enum TradeInType {
  Standard = 1,
  Appraisal = 2,
}

export default TradeInType;
